'use client';

import {
  DropdownMenuLabel,
  type DropdownMenuLabelProps,
} from '@heidi/design-system/dropdown-menu';
import { cn } from '@heidi/utils';
import * as React from 'react';

import { VariantContext, useIsActivePanel } from './context';

export const AdaptiveMenuLabel = ({
  children,
  className,
  inset,
  'data-testid': testId,
}: DropdownMenuLabelProps) => {
  const variant = React.useContext(VariantContext);
  const isActivePanel = useIsActivePanel();

  if (variant === 'menu') {
    return (
      <DropdownMenuLabel className={className} inset={inset} data-testid={testId}>
        {children}
      </DropdownMenuLabel>
    );
  }
  if (!isActivePanel) return null;
  return (
    <div
      data-testid={testId}
      className={cn('px-2 py-1.5 text-sm font-semibold', inset && 'ps-8', className)}
    >
      {children}
    </div>
  );
};
